import * as React from 'react';
import { useState } from 'react';
import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import MigrateMembers from './MigrateMembers';
import FreezeMembers from './FreezeMembers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import CreditMembers from './CreditMembers';
import CancelMembers from './CancelMembers';
import DeleteCodes from './DeleteCodes';
import MoveCodes from './MoveCodes';
import UnfreezeMembers from './UnfreezeMembers';
import { GetPlans } from '../_service/plan';
import { useContext } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { ServicePlan } from '../_types/serviceplan';
import DiscountMembers from './DiscountMembers';

interface Props {

};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      maxWidth: 700,
      borderRadius: 10,
      backgroundColor: '#fff',
      boxShadow: '2px 2px 8px rgb(50 50 93 / 20%)',
      marginTop: 20,
      padding: theme.spacing(2)
    },
  })
);

const BulkUtilities: React.FC<Props> = (prop: Props) => {
  const [utilDisplay, setUtilDisplay] = useState<string>('migrate');
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [plans, setPlans] = useState<ServicePlan[]>([]);

  // reset state when changing locations from menu bar
  React.useEffect(() => {
    setPlans([]);
    if (user.currentLocation) {
      GetPlans(user.currentLocation.id).then(res => {
        setPlans(res);
      });
    }
  }, [user.currentLocation]);

  const showUtil = () => {
    switch(utilDisplay) {
      case 'migrate':
        return <MigrateMembers plans={plans} />
      case 'delete_codes':
        return <DeleteCodes />;  
      case 'move_codes':
        return <MoveCodes />;  
      case 'freeze':
        return <FreezeMembers plans={plans} />;
      case 'unfreeze':
        return <UnfreezeMembers plans={plans} />;
      case 'gift':
        return <CreditMembers plans={plans} />;
      case 'discount':
          return <DiscountMembers plans={plans} />;
      case 'cancel':
        return <CancelMembers plans={plans} />;
      case 'uncancel':
        return 'Coming soon...';
      default:
        return '';
    }

  }

  return (
    <>
    <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={1}>
      <ToggleButtonGroup color="primary"
        value={utilDisplay}
        onChange={(event, utilDisplay) => { 
          setUtilDisplay(utilDisplay);
        }}
        exclusive>
        <ToggleButton value="migrate">Migrate Members</ToggleButton>
        <ToggleButton value="delete_codes">Delete Codes</ToggleButton>
        <ToggleButton value="move_codes">Move Codes</ToggleButton>
        <ToggleButton value="freeze">Freeze Members</ToggleButton>
        <ToggleButton value="unfreeze">Unfreeze Members</ToggleButton>
        <ToggleButton value="gift">Add Gift Credits</ToggleButton>
        <ToggleButton value="discount">Apply Discount</ToggleButton>
        <ToggleButton value="cancel">Cancel Members</ToggleButton>
        <ToggleButton value="uncancel">Uncancel Members</ToggleButton>
      </ToggleButtonGroup>
    </Grid> 
    <Grid container
          spacing={2}
          className={classes.mainContainer}
          alignItems="center">
    {showUtil()}
    </Grid> 
    </>
  )
}

export default BulkUtilities;